import { render } from "./InsuranceDetailView.vue?vue&type=template&id=eca4a2b2&scoped=true"
import script from "./InsuranceDetailView.vue?vue&type=script&lang=js"
export * from "./InsuranceDetailView.vue?vue&type=script&lang=js"

import "./InsuranceDetailView.vue?vue&type=style&index=0&id=eca4a2b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eca4a2b2"]])

export default __exports__